module.exports = __webpack_public_path__ + "static/mw7-44125119dc4d3257650e1a897944f982.jpg";